// extracted by mini-css-extract-plugin
export var modalFooter = "_qp-0";